// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-wrapper {
    margin-top: 160px;
}

.signup-underline{
    text-decoration: underline;
    font-weight: bolder;
}

.service-container {
    margin-top: 54px;
}
.service-section .card {
    margin-bottom: 40px;
    border: none;
}

/* .sell-sideibold{
    font-weight: 800;
} */

.market-right-conatiner{
    padding: 25px;
}
/* 
.market-image {
    height: 700px;
} */
 .service-section .card .card-title {
    font-size: 34px;
    color:#000;
    font-weight: 500;
    margin-top: 20px;
}
.service-section .card .card-title::before {
    content: "";
    border-left: 5px solid #ff5800;
    padding-left: 10px;
}
.service-section .card p ,.service-section .card a {
    font-size: 18px;
    color: #000;
} 
.service-section .card a i {
    color: #ff5800;
}
.service-section .card a {
    color: #333;
}
.our-services-text {
    margin-bottom: 25px;
    font-size: 50px;
    font-weight: regular;
    text-align: center;
    color: #000;
}

.service-img-wrapper {
    height: 535px;
    display: flex;
    flex-direction: row;
}

/* .img-container {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    padding: 16px 40px 35px 15px;
} */



.service-image {
    width: 100%;
    height: 100%;
    float: left;
    object-fit: cover;
    /* margin-top: 80px; */
}

a.img-container:hover .service-image { 
    transform: scale(1.05);
    transition: all 1s;
}

a.img-container:hover .service-text-gradient { 
    transform: scale(1.03);
    transition: all 1s;
}
.home-service-img {
    height:480px;
}
.service-text-gradient {
    font-size: 22px;
    color: #fff;
    font-weight: light;
    padding-left: 28px;
    padding-bottom: 28px;
    text-align: left;
    background-image: -webkit-linear-gradient(
        90deg,
        rgb(0, 0, 0) 0%,
        rgba(0, 0, 0, 0.34) 66%,
        rgba(249, 250, 253, 0) 100%
    ) !important;
    /* opacity: 0.8; */
    position: absolute;
    width: 100%;
    padding-top: 28px;
}

.img-header-container {
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}
/* .market-image {
    height: 700px;
} */
@media (max-width: 1000px) {
    .service-img-wrapper {
        flex-direction: column;
        height: auto;
    }
}
@media (max-width: 767.98px) {
    .home-service-img {
        height: auto;
    }
}
@media (max-width: 575.98px) {
    .card-body {
        padding: 15px !important;
    }
    .service-section .card .card-title {
        margin-top: 10px;
    }
    .market-image {
        height: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/home/services.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,aAAa;AACjB;AACA;;;GAGG;CACF;IACG,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;;;GAMG;;;;AAIH;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAOhB;;;;;gBAKY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;GAEG;AACH;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;AACJ;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".container-wrapper {\n    margin-top: 160px;\n}\n\n.signup-underline{\n    text-decoration: underline;\n    font-weight: bolder;\n}\n\n.service-container {\n    margin-top: 54px;\n}\n.service-section .card {\n    margin-bottom: 40px;\n    border: none;\n}\n\n/* .sell-sideibold{\n    font-weight: 800;\n} */\n\n.market-right-conatiner{\n    padding: 25px;\n}\n/* \n.market-image {\n    height: 700px;\n} */\n .service-section .card .card-title {\n    font-size: 34px;\n    color:#000;\n    font-weight: 500;\n    margin-top: 20px;\n}\n.service-section .card .card-title::before {\n    content: \"\";\n    border-left: 5px solid #ff5800;\n    padding-left: 10px;\n}\n.service-section .card p ,.service-section .card a {\n    font-size: 18px;\n    color: #000;\n} \n.service-section .card a i {\n    color: #ff5800;\n}\n.service-section .card a {\n    color: #333;\n}\n.our-services-text {\n    margin-bottom: 25px;\n    font-size: 50px;\n    font-weight: regular;\n    text-align: center;\n    color: #000;\n}\n\n.service-img-wrapper {\n    height: 535px;\n    display: flex;\n    flex-direction: row;\n}\n\n/* .img-container {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    padding: 16px 40px 35px 15px;\n} */\n\n\n\n.service-image {\n    width: 100%;\n    height: 100%;\n    float: left;\n    object-fit: cover;\n    /* margin-top: 80px; */\n}\n\na.img-container:hover .service-image { \n    transform: scale(1.05);\n    transition: all 1s;\n}\n\na.img-container:hover .service-text-gradient { \n    transform: scale(1.03);\n    transition: all 1s;\n}\n.home-service-img {\n    height:480px;\n}\n.service-text-gradient {\n    font-size: 22px;\n    color: #fff;\n    font-weight: light;\n    padding-left: 28px;\n    padding-bottom: 28px;\n    text-align: left;\n    background-image: -moz-linear-gradient(\n        90deg,\n        rgb(0, 0, 0) 0%,\n        rgba(0, 0, 0, 0.34) 66%,\n        rgba(249, 250, 253, 0) 100%\n    ) !important;\n    background-image: -webkit-linear-gradient(\n        90deg,\n        rgb(0, 0, 0) 0%,\n        rgba(0, 0, 0, 0.34) 66%,\n        rgba(249, 250, 253, 0) 100%\n    ) !important;\n    /* opacity: 0.8; */\n    position: absolute;\n    width: 100%;\n    padding-top: 28px;\n}\n\n.img-header-container {\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n}\n/* .market-image {\n    height: 700px;\n} */\n@media (max-width: 1000px) {\n    .service-img-wrapper {\n        flex-direction: column;\n        height: auto;\n    }\n}\n@media (max-width: 767.98px) {\n    .home-service-img {\n        height: auto;\n    }\n}\n@media (max-width: 575.98px) {\n    .card-body {\n        padding: 15px !important;\n    }\n    .service-section .card .card-title {\n        margin-top: 10px;\n    }\n    .market-image {\n        height: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
